import React from 'react';
import { Center, Flex, Spinner, Text } from '@chakra-ui/react';

import { useTranslations } from '../../../contexts/LocalizationContext';

export const ProcessSpinner = () => {
  const translations = useTranslations();

  return (
    <Center py={4}>
      <Flex direction={'column'}>
        <Text fontSize={20} fontWeight={'bold'} p={4}>
          {translations('processing')}
        </Text>
        <Center p={4}>
          <Spinner thickness="12px" speed="0.8s" emptyColor="orange.100" color="orange.500" size="xl" />
        </Center>
      </Flex>
    </Center>
  );
};
